import adminHttp from "/src/api/adminHttp";

// MLBB Esports API (Moonton) — трансляции. Дока: Postman «MLBB Esports Broadcast».
// Админские ручки только для роли admin, клиентские публичные.
const ADMIN = '/api/v1/admin/mlbb/esports';
const CLIENT = '/api/v1/client/mlbb';

export default {
    /* ---------- судьи (аккаунты-рефери, по ним ищутся battle) ---------- */

    /**
     * GET: список судей
     * @returns {Promise<AxiosResponse<{data: Array}>>}
     */
    judges: () => adminHttp.get(`${ADMIN}/judges`),

    /**
     * POST: добавить судью. judge_id обязателен и уникален (422 при дубле)
     * @param {{judge_id: number, name?: string, is_active?: boolean}} data
     */
    storeJudge: (data) => adminHttp.post(`${ADMIN}/judges`, data),

    /**
     * PATCH: изменить судью (любые из полей judge_id, name, is_active)
     * @param {number} id — mlbb_judges.id (не игровой ID)
     * @param {Object} data
     */
    updateJudge: (id, data) => adminHttp.patch(`${ADMIN}/judges/${id}`, data),

    /**
     * DELETE: удалить судью
     * @param {number} id — mlbb_judges.id
     */
    deleteJudge: (id) => adminHttp.delete(`${ADMIN}/judges/${id}`),

    /* ---------- battle (одна игра серии) ---------- */

    /**
     * GET: список battle, пагинация по 30, новые сверху
     * @param {Object} params — judge_id (игровой), group_id, state, unlinked=1, poll_enabled, page
     * @param {Object} [config] — axios-конфиг (skipErrorToast и т.п.)
     */
    battles: (params = {}, config = {}) => adminHttp.get(`${ADMIN}/battles`, {params, ...config}),

    /**
     * GET: battle с camps и players плюс служебные поля опроса
     * @param {number} id — mlbb_battles.id
     * @param {Object} [config]
     */
    battle: (id, config = {}) => adminHttp.get(`${ADMIN}/battles/${id}`, config),

    /**
     * POST: привязать battle к нашему матчу. 422 — группы нет
     * @param {number} id — mlbb_battles.id
     * @param {number} groupId — new_groups.id
     */
    linkBattle: (id, groupId) => adminHttp.post(`${ADMIN}/battles/${id}/link`, {group_id: groupId}),

    /**
     * POST: снять привязку к матчу
     * @param {number} id — mlbb_battles.id
     */
    unlinkBattle: (id) => adminHttp.post(`${ADMIN}/battles/${id}/unlink`),

    /**
     * POST: снова включить опрос Moonton и дёрнуть его один раз
     * @param {number} id — mlbb_battles.id
     */
    resyncBattle: (id) => adminHttp.post(`${ADMIN}/battles/${id}/resync`),

    /* ---------- клиентские (публичные) ---------- */

    /**
     * GET: все игры матча (серии) по порядку
     * @param {number} groupId
     * @param {Object} [config]
     */
    groupBattles: (groupId, config = {}) => adminHttp.get(`${CLIENT}/groups/${groupId}/battles`, config),

    /**
     * GET: лента событий battle
     * @param {number} id — mlbb_battles.id
     * @param {Object} params — since_game_time, event_type, per_page (до 500), page
     * @param {Object} [config]
     */
    battleEvents: (id, params = {}, config = {}) =>
        adminHttp.get(`${CLIENT}/battles/${id}/events`, {params, ...config}),

    /**
     * GET: точки таймлайна (разница золота / опыта / киллов / башен)
     * @param {number} id — mlbb_battles.id
     * @param {Object} params — since_game_time, step
     * @param {Object} [config]
     */
    battleTimeline: (id, params = {}, config = {}) =>
        adminHttp.get(`${CLIENT}/battles/${id}/timeline`, {params, ...config}),

    /**
     * GET: справочник героев (без пагинации). Игровой ID — hero_id, id — внутренний id бэка
     * @returns {Promise<AxiosResponse<{data: Array<{id: number, hero_id: number, name: string, avatar: {original_url: string, webp: string, small_webp: string}}>}>>}
     */
    heroes: (config = {}) => adminHttp.get(`${CLIENT}/heroes`, config),

    /* Справочники Moonton: без пагинации, id — ID игры (то же число, что в battle).
       Элемент: {id, name, description|null, icon: URL|null}. Язык по Accept-Language (adminHttp шлёт ru) */

    /** GET: боевые заклинания — players[].skill_id */
    spells: (config = {}) => adminHttp.get(`${CLIENT}/spells`, config),

    /** GET: предметы, плюс gold, category, category_name — players[].equip_list[] */
    items: (config = {}) => adminHttp.get(`${CLIENT}/items`, config),

    /** GET: эмблемы — players[].rune_id */
    emblems: (config = {}) => adminHttp.get(`${CLIENT}/emblems`, config),

    /** GET: таланты, плюс emblem_id — ключи players[].rune_map {id: уровень} */
    talents: (config = {}) => adminHttp.get(`${CLIENT}/talents`, config),
};
